module.exports = __webpack_public_path__ + "media/dragon.a26a103f.mp3";